<div class="custom-menu-wrapper">
  <button
    pButton
    type="button"
    class="custom-menu-button"
    (click)="menu.toggle($event)"
    [disabled]="status !== 'Pending'"
    [ngStyle]="{ 'background-color': getDropdownBgColor()}">
    <span class="menu-label">{{ status }}</span>
    @if(status === 'Pending'){
    <i class="pi pi-angle-down menu-arrow"></i>
    }
  </button>

  <p-menu #menu [popup]="true" [model]="menuItems" appendTo="body" styleClass="menu-width">
    <ng-template let-item pTemplate="item">
      <div class="menu-item-custom">
        <span class="item-label">{{ item.label }}</span>
        @if(item.icon) {
        <i class="pi {{ item.icon }} item-icon"></i>
        }
      </div>
    </ng-template>
  </p-menu>
</div>

<p-dialog [(visible)]="showDialog" [modal]="true" [closable]="false" [header]="dialogHeader" (onHide)="onDialogCancel()"
  [style]="{width: '50vw'}">
  <div class="p-fluid">
    <span class="font-bold">{{ dialogMessage }}</span>
    <form [formGroup]="commentForm">
      <div class="pt-16">
        <div class="mb-1">
          <div class="pb-2">
            <label for="approvalReason" class="font-bold" translate>change_review.lbl_enter_reason</label>
            <span class="text-red-500 ml-1">*</span>
          </div>

          <div class="mb-1 input-text">
            <textarea id="approvalReason" formControlName="approvalReason" pInputTextarea rows="5"
              class="p-component p-element w-full" maxlength="500"></textarea>
          </div>
          <div class="form-hint mt-1">
            <small class="text-muted">({{ 'change_review.lbl_change_reason_max_hint' | translate }})</small>
          </div>

          @if(commentForm.get('approvalReason')?.invalid && commentForm.get('approvalReason')?.touched){
          <div class="form-errors mt-1 required-field">
            @if(commentForm.get('approvalReason')?.errors?.required){
            <div translate>change_review.lbl_error_message</div>
            }
            @if(commentForm.get('approvalReason')?.errors?.whitespaceOnly){
            <div translate>change_review.lbl_error_message</div>
            }
            @if(commentForm.get('approvalReason')?.errors?.maxlength){
            <div translate>change_review.lbl_change_reason_max</div>
            }
          </div>
          }
        </div>
      </div>
    </form>
  </div>

  <div class="col-12 flex justify-content-end px-0 pt-3 pb-0">
    <button class="mr-2 bg-white border-button default-text-light-black-color cursor-pointer cancel-dialog"
      (click)="onDialogCancel()" [label]="'cancel' | translate" pButton></button>
    <p-button [label]="dialogActionButtonLabel" severity="danger" (click)="onDialogConfirm()"
      [disabled]="commentForm.invalid"></p-button>
  </div>

</p-dialog>